import { render, staticRenderFns } from "./task_messaging_forwards_dialog.vue?vue&type=template&id=13d3ab40"
import script from "./task_messaging_forwards_dialog.vue?vue&type=script&lang=js"
export * from "./task_messaging_forwards_dialog.vue?vue&type=script&lang=js"
import style0 from "./task_messaging_forwards_dialog.vue?vue&type=style&index=0&id=13d3ab40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports